module.exports = __webpack_public_path__ + "static/img/hospital-2.03bbf71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/hospital-2.png
// module id = mr06
// module chunks = 35